
import { Video, SearchResult, ClipResult, TranscriptSegment } from '@/types';

// Enhanced mock data for comprehensive search demonstration
const MOCK_VIDEOS: Video[] = [
  {
    id: 'v1',
    title: 'Introduction to Video Analysis and AI Processing',
    duration: 648, // 10:48
    thumbnail: 'https://images.unsplash.com/photo-1605810230434-7631ac76ec81?w=500&h=280&fit=crop',
    processingStatus: 'completed',
    createdAt: '2024-01-15T14:30:00Z',
    metadata: {
      speakers: ['Dr. Sarah Chen', 'John Martinez'],
      objects: ['laptop', 'camera', 'whiteboard', 'presentation screen', 'microphone'],
      frameCount: 15552,
      segmentCount: 87
    }
  },
  {
    id: 'v2',
    title: 'Advanced Guitar Techniques for Beginners',
    duration: 1824, // 30:24
    thumbnail: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=500&h=280&fit=crop',
    processingStatus: 'completed',
    createdAt: '2024-01-12T10:15:00Z',
    metadata: {
      speakers: ['Marcus Thompson', 'Lisa Rodriguez'],
      objects: ['acoustic guitar', 'electric guitar', 'amplifier', 'microphone', 'music stand', 'pick'],
      frameCount: 43776,
      segmentCount: 145
    }
  },
  {
    id: 'v3',
    title: 'Corporate Quarterly Review Meeting',
    duration: 2142, // 35:42
    thumbnail: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=500&h=280&fit=crop',
    processingStatus: 'completed',
    createdAt: '2024-01-10T09:20:00Z',
    metadata: {
      speakers: ['CEO Amanda Wilson', 'CFO Robert Kim', 'VP Sales Jennifer Lee'],
      objects: ['conference table', 'laptop', 'projector', 'charts', 'coffee cups', 'notepads'],
      frameCount: 51408,
      segmentCount: 198
    }
  },
  {
    id: 'v4',
    title: 'Python Programming Tutorial: Web Scraping',
    duration: 1456, // 24:16
    thumbnail: 'https://images.unsplash.com/photo-1461749280684-dccba630e2f6?w=500&h=280&fit=crop',
    processingStatus: 'completed',
    createdAt: '2024-01-08T16:45:00Z',
    metadata: {
      speakers: ['Alex Developer'],
      objects: ['laptop screen', 'code editor', 'browser', 'keyboard', 'mouse', 'headphones'],
      frameCount: 34944,
      segmentCount: 112
    }
  },
  {
    id: 'v5',
    title: 'Product Launch Presentation - Smart Home Devices',
    duration: 956, // 15:56
    thumbnail: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=500&h=280&fit=crop',
    processingStatus: 'completed',
    createdAt: '2024-01-05T11:30:00Z',
    metadata: {
      speakers: ['Product Manager Steve Walsh', 'Engineer Maria Santos'],
      objects: ['smart speaker', 'tablet', 'presentation screen', 'product prototypes', 'remote control'],
      frameCount: 22944,
      segmentCount: 76
    }
  },
  {
    id: 'v6',
    title: 'Cooking Masterclass: Italian Pasta Making',
    duration: 1638, // 27:18
    thumbnail: 'https://images.unsplash.com/photo-1565299624946-b28f40a0ca4b?w=500&h=280&fit=crop',
    processingStatus: 'completed',
    createdAt: '2024-01-03T14:20:00Z',
    metadata: {
      speakers: ['Chef Antonio Rossi'],
      objects: ['pasta machine', 'flour', 'eggs', 'rolling pin', 'kitchen counter', 'apron'],
      frameCount: 39312,
      segmentCount: 134
    }
  },
  {
    id: 'v7',
    title: 'Machine Learning Conference Keynote',
    duration: 2847, // 47:27
    thumbnail: 'https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=500&h=280&fit=crop',
    processingStatus: 'completed',
    createdAt: '2024-01-01T13:15:00Z',
    metadata: {
      speakers: ['Dr. Emily Watson', 'Research Lead Tom Zhang'],
      objects: ['large screen', 'podium', 'microphone', 'audience', 'laptop', 'laser pointer'],
      frameCount: 68328,
      segmentCount: 234
    }
  },
  {
    id: 'v8',
    title: 'Weekly Team Standup - Development Team',
    duration: 432, // 7:12
    thumbnail: 'https://images.unsplash.com/photo-1553877522-43269d4ea984?w=500&h=280&fit=crop',
    processingStatus: 'completed',
    createdAt: '2023-12-28T09:00:00Z',
    metadata: {
      speakers: ['Scrum Master Kate Johnson', 'Developer Mike Chen', 'Designer Amy Foster'],
      objects: ['whiteboard', 'sticky notes', 'laptops', 'coffee mugs', 'standing desks'],
      frameCount: 10368,
      segmentCount: 43
    }
  },
  {
    id: 'v9',
    title: 'Piano Lesson: Classical Music Fundamentals',
    duration: 1245, // 20:45
    thumbnail: 'https://images.unsplash.com/photo-1520523839897-bd0b52f945a0?w=500&h=280&fit=crop',
    processingStatus: 'processing',
    processingProgress: 75,
    createdAt: '2023-12-25T15:30:00Z',
    metadata: {
      speakers: ['Professor Diana Clarke'],
      objects: ['grand piano', 'music sheets', 'metronome', 'piano bench'],
      frameCount: 29880,
      segmentCount: 98
    }
  },
  {
    id: 'v10',
    title: 'Design System Workshop - UX Best Practices',
    duration: 1789, // 29:49
    thumbnail: 'https://images.unsplash.com/photo-1581291518633-83b4ebd1d83e?w=500&h=280&fit=crop',
    processingStatus: 'completed',
    createdAt: '2023-12-22T10:45:00Z',
    metadata: {
      speakers: ['UX Lead Rachel Green', 'Design Manager Paul Davis'],
      objects: ['design mockups', 'tablet', 'stylus', 'computer monitor', 'sketch pad'],
      frameCount: 42936,
      segmentCount: 156
    }
  },
  {
    id: 'v11',
    title: 'Customer Interview Session - User Research',
    duration: 1567, // 26:07
    thumbnail: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=500&h=280&fit=crop',
    processingStatus: 'completed',
    createdAt: '2023-12-20T14:00:00Z',
    metadata: {
      speakers: ['Researcher Jane Smith', 'Customer Bob Miller'],
      objects: ['recording device', 'notepad', 'water glasses', 'comfortable chairs'],
      frameCount: 37608,
      segmentCount: 128
    }
  },
  {
    id: 'v12',
    title: 'Startup Pitch to Investors',
    duration: 892, // 14:52
    thumbnail: 'https://images.unsplash.com/photo-1556761175-4b46a572b786?w=500&h=280&fit=crop',
    processingStatus: 'completed',
    createdAt: '2023-12-18T16:20:00Z',
    metadata: {
      speakers: ['Founder Jessica Liu', 'CTO David Park'],
      objects: ['presentation slides', 'laptop', 'investor table', 'business plan', 'water pitcher'],
      frameCount: 21408,
      segmentCount: 74
    }
  },
  {
    id: 'v13',
    title: 'Fitness Training: Home Workout Routine',
    duration: 1823, // 30:23
    thumbnail: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=500&h=280&fit=crop',
    processingStatus: 'processing',
    processingProgress: 45,
    createdAt: '2023-12-15T07:30:00Z',
    metadata: {
      speakers: ['Trainer Michael Brown'],
      objects: ['exercise mat', 'dumbbells', 'resistance bands', 'water bottle', 'towel'],
      frameCount: 43752,
      segmentCount: 167
    }
  },
  {
    id: 'v14',
    title: 'Tech Conference Panel: Future of AI',
    duration: 3245, // 54:05
    thumbnail: 'https://images.unsplash.com/photo-1515187029135-18ee286d815b?w=500&h=280&fit=crop',
    processingStatus: 'completed',
    createdAt: '2023-12-12T11:15:00Z',
    metadata: {
      speakers: ['Moderator Claire Adams', 'AI Expert Dr. Kevin Wu', 'Tech CEO Linda Garcia', 'Ethics Professor James Brooks'],
      objects: ['panel table', 'microphones', 'audience', 'large display', 'name plates'],
      frameCount: 77880,
      segmentCount: 287
    }
  },
  {
    id: 'v15',
    title: 'Photography Tutorial: Portrait Lighting',
    duration: 1134, // 18:54
    thumbnail: 'https://images.unsplash.com/photo-1502920917128-1aa500764cbd?w=500&h=280&fit=crop',
    processingStatus: 'completed',
    createdAt: '2023-12-10T13:45:00Z',
    metadata: {
      speakers: ['Photographer Emma Wilson'],
      objects: ['camera', 'lighting equipment', 'backdrop', 'tripod', 'reflector', 'model'],
      frameCount: 27216,
      segmentCount: 95
    }
  },
  {
    id: 'v16',
    title: 'Board Meeting: Strategic Planning 2024',
    duration: 2456, // 40:56
    thumbnail: 'https://images.unsplash.com/photo-1556484687-30636164638b?w=500&h=280&fit=crop',
    processingStatus: 'pending',
    createdAt: '2023-12-08T09:30:00Z'
  }
];

// Enhanced transcript data with more realistic content
const MOCK_TRANSCRIPT: TranscriptSegment[] = [
  { startTime: 0, endTime: 5.2, text: "Welcome everyone to today's presentation on advanced video analysis techniques.", speaker: "Dr. Sarah Chen" },
  { startTime: 5.5, endTime: 10.8, text: "Today we'll explore how AI can extract meaningful insights from video content at scale.", speaker: "Dr. Sarah Chen" },
  { startTime: 11.2, endTime: 18.6, text: "Let's start by discussing object detection capabilities in modern video processing systems.", speaker: "Dr. Sarah Chen" },
  { startTime: 19.1, endTime: 25.4, text: "John, could you demonstrate the real-time object recognition we've been developing?", speaker: "Dr. Sarah Chen" },
  { startTime: 26.0, endTime: 32.5, text: "Absolutely Sarah. Here you can see our system identifying multiple objects simultaneously.", speaker: "John Martinez" },
  { startTime: 33.1, endTime: 40.7, text: "The camera is detecting my laptop, the whiteboard behind me, and even the microphone I'm using.", speaker: "John Martinez" },
  { startTime: 41.3, endTime: 48.9, text: "This level of detailed analysis enables users to search for specific visual content across their entire video library.", speaker: "John Martinez" },
  { startTime: 49.5, endTime: 58.0, text: "For example, someone could search for 'person presenting with laptop' and find this exact moment.", speaker: "John Martinez" },
  { startTime: 59.0, endTime: 67.3, text: "The system also analyzes speaker patterns and can distinguish between different voices in multi-speaker scenarios.", speaker: "Dr. Sarah Chen" },
  { startTime: 68.0, endTime: 75.8, text: "This makes it possible to search for specific speakers or filter content by who's talking.", speaker: "Dr. Sarah Chen" }
];

const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

// Interface for processing options
interface ProcessingOptions {
  enhanceQuality?: boolean;
  detectObjects?: boolean;
  identifySpeakers?: boolean;
  generateChapters?: boolean;
  resolution?: number;
  processingIntensity?: number;
}

// Mock API for videos
export const videoApi = {
  getVideos: async (): Promise<Video[]> => {
    await delay(800);
    return [...MOCK_VIDEOS];
  },
  
  getVideoById: async (id: string): Promise<Video | undefined> => {
    await delay(600);
    return MOCK_VIDEOS.find(video => video.id === id);
  },
  
  uploadVideo: async (file: File): Promise<{ id: string; status: string }> => {
    await delay(1500);
    return { 
      id: `v${Math.floor(Math.random() * 1000)}`, 
      status: 'pending' 
    };
  },
  
  processVideo: async (videoId: string, options: ProcessingOptions): Promise<{ status: string }> => {
    await delay(1000);
    console.log(`Processing video ${videoId} with options:`, options);
    return {
      status: 'processing'
    };
  },
  
  reprocessVideo: async (videoId: string, options: ProcessingOptions): Promise<{ status: string }> => {
    await delay(1000);
    console.log(`Reprocessing video ${videoId} with options:`, options);
    return {
      status: 'processing'
    };
  },
  
  getVideoStatus: async (id: string): Promise<{ status: string; progress?: number }> => {
    await delay(300);
    const video = MOCK_VIDEOS.find(v => v.id === id);
    return { 
      status: video?.processingStatus || 'pending',
      progress: video?.processingProgress
    };
  },
  
  getVideoTranscript: async (id: string): Promise<TranscriptSegment[]> => {
    await delay(700);
    return [...MOCK_TRANSCRIPT];
  }
};

// Mock API for search
export const searchApi = {
  searchInVideo: async (videoId: string, query: string): Promise<SearchResult[]> => {
    await delay(1000);
    return [
      {
        type: 'segment',
        videoId,
        startTime: 15.2,
        endTime: 25.4,
        text: "...discussing the concept of object detection in video frames. Object detection allows us to identify and locate specific items...",
        speaker: "Dr. Sarah Chen",
        relevance: 0.92
      },
      {
        type: 'segment',
        videoId,
        startTime: 41.3,
        endTime: 48.9,
        text: "Users can search for specific moments where both visual and spoken content match their query.",
        speaker: "John Martinez",
        relevance: 0.85
      }
    ];
  },
  
  searchAcrossVideos: async (query: string): Promise<SearchResult[]> => {
    await delay(1200);
    return [
      {
        type: 'segment',
        videoId: 'v1',
        startTime: 15.2,
        endTime: 25.4,
        text: "...discussing the concept of object detection in video frames. Object detection allows us to identify and locate specific items...",
        speaker: "Dr. Sarah Chen",
        relevance: 0.92
      },
      {
        type: 'segment',
        videoId: 'v2',
        startTime: 120.5,
        endTime: 135.1,
        text: "...sophisticated algorithms to detect patterns in video content and extract meaningful insights...",
        speaker: "Marcus Thompson",
        relevance: 0.78
      }
    ];
  },
  
  semanticSearchAcrossVideos: async (query: string, filters?: any): Promise<SearchResult[]> => {
    await delay(1500);
    
    // Comprehensive semantic search results database
    const allSemanticResults: SearchResult[] = [
      // Person presenting results
      {
        type: 'segment',
        videoId: 'v1',
        startTime: 0,
        endTime: 18.6,
        text: "Welcome everyone to today's presentation on advanced video analysis techniques. Today we'll explore how AI can extract meaningful insights from video content.",
        speaker: "Dr. Sarah Chen",
        objects: ['person', 'presentation screen', 'laptop', 'whiteboard', 'microphone'],
        relevance: 0.95,
        sceneContext: "Professional conference presentation",
        visualDescription: "Woman presenting to audience with slides and whiteboard behind her"
      },
      {
        type: 'visual',
        videoId: 'v5',
        startTime: 120.5,
        endTime: 120.5,
        objects: ['person', 'presentation screen', 'tablet', 'product prototypes'],
        relevance: 0.93,
        sceneContext: "Product launch presentation",
        visualDescription: "Product manager presenting smart home devices to audience"
      },
      {
        type: 'segment',
        videoId: 'v7',
        startTime: 45.2,
        endTime: 68.9,
        text: "The future of machine learning lies in our ability to process and understand multimodal data streams.",
        speaker: "Dr. Emily Watson",
        objects: ['person', 'podium', 'large screen', 'microphone', 'audience'],
        relevance: 0.91,
        sceneContext: "Conference keynote presentation",
        visualDescription: "Keynote speaker presenting ML concepts to large tech conference audience"
      },
      {
        type: 'segment',
        videoId: 'v12',
        startTime: 15.8,
        endTime: 45.3,
        text: "Our startup has developed revolutionary technology that will transform how businesses interact with their customers.",
        speaker: "Jessica Liu",
        objects: ['person', 'presentation slides', 'laptop', 'investor table'],
        relevance: 0.89,
        sceneContext: "Startup pitch presentation",
        visualDescription: "Founder presenting business pitch to panel of investors"
      },
      
      // Guitar playing results
      {
        type: 'segment',
        videoId: 'v2',
        startTime: 45.1,
        endTime: 72.4,
        text: "Let me demonstrate the proper finger positioning for this chord progression on the acoustic guitar.",
        speaker: "Marcus Thompson",
        objects: ['person', 'acoustic guitar', 'music stand', 'pick'],
        relevance: 0.96,
        sceneContext: "Guitar lesson tutorial",
        visualDescription: "Music instructor demonstrating chord fingering on acoustic guitar"
      },
      {
        type: 'visual',
        videoId: 'v2',
        startTime: 156.7,
        endTime: 156.7,
        objects: ['person', 'electric guitar', 'amplifier', 'microphone'],
        relevance: 0.94,
        sceneContext: "Electric guitar demonstration",
        visualDescription: "Close-up of hands playing electric guitar with amplifier visible"
      },
      {
        type: 'segment',
        videoId: 'v2',
        startTime: 890.2,
        endTime: 925.8,
        text: "Notice how the guitar resonates differently when played in various positions along the neck.",
        speaker: "Lisa Rodriguez",
        objects: ['person', 'acoustic guitar', 'microphone'],
        relevance: 0.88,
        sceneContext: "Advanced guitar technique lesson",
        visualDescription: "Guitar instructor explaining neck positioning while playing"
      },
      
      // Laptop screen results
      {
        type: 'segment',
        videoId: 'v4',
        startTime: 125.3,
        endTime: 158.7,
        text: "Here on my laptop screen, you can see the Python code for web scraping using BeautifulSoup library.",
        speaker: "Alex Developer",
        objects: ['person', 'laptop screen', 'code editor', 'browser', 'keyboard'],
        relevance: 0.97,
        sceneContext: "Programming tutorial",
        visualDescription: "Developer showing code on laptop screen while explaining web scraping concepts"
      },
      {
        type: 'visual',
        videoId: 'v1',
        startTime: 234.5,
        endTime: 234.5,
        objects: ['laptop screen', 'presentation', 'person', 'whiteboard'],
        relevance: 0.85,
        sceneContext: "Technical presentation with laptop",
        visualDescription: "Laptop screen showing technical diagrams during presentation"
      },
      {
        type: 'segment',
        videoId: 'v10',
        startTime: 445.2,
        endTime: 478.9,
        text: "The design mockups displayed on my laptop screen show our new component library structure.",
        speaker: "Rachel Green",
        objects: ['person', 'laptop screen', 'design mockups', 'tablet', 'stylus'],
        relevance: 0.83,
        sceneContext: "Design system workshop",
        visualDescription: "UX designer showing design mockups on laptop during workshop"
      },
      
      // Whiteboard discussion results
      {
        type: 'segment',
        videoId: 'v8',
        startTime: 78.4,
        endTime: 125.6,
        text: "Let's update our sprint board on the whiteboard to track our development progress this week.",
        speaker: "Kate Johnson",
        objects: ['person', 'whiteboard', 'sticky notes', 'laptops', 'standing desks'],
        relevance: 0.92,
        sceneContext: "Team standup meeting",
        visualDescription: "Scrum master updating whiteboard with sticky notes during team meeting"
      },
      {
        type: 'visual',
        videoId: 'v1',
        startTime: 345.8,
        endTime: 345.8,
        objects: ['whiteboard', 'diagrams', 'person', 'presentation'],
        relevance: 0.87,
        sceneContext: "Technical whiteboard session",
        visualDescription: "Whiteboard filled with technical diagrams and flowcharts"
      },
      
      // Microphone setup results
      {
        type: 'visual',
        videoId: 'v2',
        startTime: 12.3,
        endTime: 12.3,
        objects: ['microphone', 'acoustic guitar', 'recording setup', 'music stand'],
        relevance: 0.91,
        sceneContext: "Music recording setup",
        visualDescription: "Professional microphone positioned for recording acoustic guitar"
      },
      {
        type: 'segment',
        videoId: 'v11',
        startTime: 5.2,
        endTime: 18.9,
        text: "I'm adjusting the microphone setup to ensure we capture clear audio for this customer interview.",
        speaker: "Jane Smith",
        objects: ['microphone', 'recording device', 'person', 'comfortable chairs'],
        relevance: 0.89,
        sceneContext: "Interview recording setup",
        visualDescription: "Researcher setting up microphone for customer interview session"
      },
      
      // Meeting and conference results
      {
        type: 'segment',
        videoId: 'v3',
        startTime: 234.7,
        endTime: 289.4,
        text: "Our quarterly revenue exceeded expectations, and I want to discuss the key factors behind this success.",
        speaker: "CEO Amanda Wilson",
        objects: ['person', 'conference table', 'laptop', 'charts', 'projector'],
        relevance: 0.85,
        sceneContext: "Corporate quarterly review",
        visualDescription: "CEO presenting quarterly results at conference table meeting"
      },
      {
        type: 'segment',
        videoId: 'v14',
        startTime: 567.3,
        endTime: 612.8,
        text: "The ethical implications of AI development require careful consideration from all stakeholders.",
        speaker: "James Brooks",
        objects: ['person', 'panel table', 'microphones', 'audience', 'name plates'],
        relevance: 0.79,
        sceneContext: "AI ethics panel discussion",
        visualDescription: "Ethics professor speaking at tech conference panel"
      }
    ];
    
    if (!query.trim()) return [];
    
    const queryLower = query.toLowerCase();
    const matchingResults = allSemanticResults.filter(result => {
      const matchesText = result.text?.toLowerCase().includes(queryLower);
      const matchesObjects = result.objects?.some(obj => 
        queryLower.split(' ').some(word => obj.toLowerCase().includes(word))
      );
      const matchesContext = result.sceneContext?.toLowerCase().includes(queryLower);
      const matchesDescription = result.visualDescription?.toLowerCase().includes(queryLower);
      const matchesSpeaker = result.speaker?.toLowerCase().includes(queryLower);
      
      // Enhanced semantic matching for common phrases
      const semanticMatches = [
        { phrases: ['person presenting', 'presentation', 'presenter'], keywords: ['person', 'presentation', 'presenting', 'speaker'] },
        { phrases: ['guitar playing', 'guitar music', 'guitar lesson'], keywords: ['guitar', 'music', 'playing', 'lesson'] },
        { phrases: ['laptop screen', 'computer screen', 'coding'], keywords: ['laptop', 'screen', 'computer', 'code'] },
        { phrases: ['whiteboard discussion', 'whiteboard meeting'], keywords: ['whiteboard', 'discussion', 'meeting'] },
        { phrases: ['microphone setup', 'recording setup'], keywords: ['microphone', 'recording', 'setup'] }
      ];
      
      const semanticMatch = semanticMatches.some(({ phrases, keywords }) => {
        const queryMatchesPhrase = phrases.some(phrase => queryLower.includes(phrase));
        const resultMatchesKeywords = keywords.some(keyword => 
          result.text?.toLowerCase().includes(keyword) ||
          result.objects?.some(obj => obj.toLowerCase().includes(keyword)) ||
          result.sceneContext?.toLowerCase().includes(keyword) ||
          result.visualDescription?.toLowerCase().includes(keyword)
        );
        return queryMatchesPhrase && resultMatchesKeywords;
      });
      
      return matchesText || matchesObjects || matchesContext || matchesDescription || matchesSpeaker || semanticMatch;
    });
    
    return matchingResults.sort((a, b) => b.relevance - a.relevance).slice(0, 20);
  }
};

// Mock API for clip generation
export const clipApi = {
  generateClip: async (videoId: string, query: string, options?: { smartMerge?: boolean, includeCaptions?: boolean, paddingSeconds?: number }): Promise<ClipResult> => {
    await delay(2000);
    return {
      clipId: `clip-${Math.floor(Math.random() * 1000)}`,
      videoId,
      query,
      clipPath: "/mock-clip-path.mp4",
      thumbnail: "https://images.unsplash.com/photo-1500673922987-e212871fec22?w=500&h=280&fit=crop",
      originalStart: 15.2,
      originalEnd: 48.9,
      paddedStart: options?.paddingSeconds ? 15.2 - options.paddingSeconds : 15.2,
      paddedEnd: options?.paddingSeconds ? 48.9 + options.paddingSeconds : 48.9
    };
  },
  
  getClip: async (clipId: string): Promise<ClipResult> => {
    await delay(500);
    return {
      clipId,
      videoId: 'v1',
      query: "object detection",
      clipPath: "/mock-clip-path.mp4",
      thumbnail: "https://images.unsplash.com/photo-1500673922987-e212871fec22?w=500&h=280&fit=crop",
      originalStart: 15.2,
      originalEnd: 48.9,
      paddedStart: 15.2,
      paddedEnd: 48.9
    };
  }
};
